import Component from '@glimmer/component';
import { service } from '@ember/service';
import { restartableTask } from 'ember-concurrency';
import { t } from 'ember-intl';
import type Store from '@ember-data/store';
import type FamilyInviteModel from 'tio-data/models/family-invite';
import type EmployeeModel from 'tio-data/models/employee';
import Table from 'tio-reimagined/components/table';
import type Owner from '@ember/owner';
import type FamilyModel from 'tio-data/models/family';
import { tracked } from '@glimmer/tracking';

interface FamilyInvitesTableSignature {
  Args: {
    limit: number;
    employees: EmployeeModel[];
  };
}

export default class FamilyInvitesTableComponent extends Component<FamilyInvitesTableSignature> {
  @service declare store: Store;

  constructor(owner: Owner, args: FamilyInvitesTableSignature['Args']) {
    super(owner, args);
    this.loadRecords.perform();
  }

  @tracked familyInvites?: FamilyInviteModel[];

  get isLoading() {
    return this.loadRecords.isRunning;
  }

  get employees() {
    return this.args.employees?.slice() || [];
  }

  loadRecords = restartableTask(async () => {
    const page = {
      limit: this.args.limit,
      offset: 0,
    };

    const filter = {
      employee: this.employees[0]?.get('id') || '',
    };
    // @ts-expect-error: ed
    this.familyInvites = await this.store.query<FamilyModel>('family', {
      filter,
      page,
      include: 'family-invites,user',
    });
  });

  <template>
    <Table @isLoading={{this.isLoading}}>
      <:thead as |options|>
        <options.tr>
          <options.th>{{t "common.profile.family_invites.family_id"}}</options.th>
          <options.th>{{t "common.profile.family_invites.name"}}</options.th>
          <options.th>{{t "common.profile.family_invites.user_id"}}</options.th>
          <options.th>{{t "common.profile.family_invites.relationship"}}</options.th>
        </options.tr>
      </:thead>
      <:tbody as |options|>
        {{#each this.familyInvites as |invite|}}
          <options.tr>
            <options.td>{{invite.id}}</options.td>
            {{!-- <options.td>{{invite.fullName}}</options.td>
            <options.td>{{invite.user.id}}</options.td>
            <options.td>{{invite.familyRelationshipTypeId}}</options.td> --}}
          </options.tr>
        {{/each}}
      </:tbody>
    </Table>
  </template>
}
